module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("21POK"))).then(() => parcelRequire('fThBo'));